import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  static targets = ['offcanvas']

  connect() {
    this.offcanvas = new bootstrap.Offcanvas(this.offcanvasTarget, {backdrop: this.offcanvasTarget.dataset.offcanvasBackdrop, scroll: false})
    this.originalFocusTrap = this.offcanvas._focustrap;
    this.disableFocus();
    this.offcanvas.show()
  }

  open() {
    this.offcanvas.show()
  }

  close(event) {
    this.enableFocus();
    event.preventDefault();
    this.offcanvas.hide()
  }

  enableFocus() {
    this.offcanvas._focustrap = this.originalFocusTrap;
  }

  disableFocus() {
    this.offcanvas._focustrap = { activate: () => {}, deactivate: () => {} };
  }
}
